import { render, staticRenderFns } from "./ConflictInstructionTableField.vue?vue&type=template&id=9fa1d36e&scoped=true"
import script from "./ConflictInstructionTableField.vue?vue&type=script&lang=js"
export * from "./ConflictInstructionTableField.vue?vue&type=script&lang=js"
import style0 from "./ConflictInstructionTableField.vue?vue&type=style&index=0&id=9fa1d36e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fa1d36e",
  null
  
)

export default component.exports